import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const MainDataIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19.708"
      height="26.162"
      viewBox="0 0 19.708 26.162"
    >
      <g id="book-2" transform="translate(-63.157)">
        <g id="Group_118" data-name="Group 118" transform="translate(63.157)">
          <g id="Group_117" data-name="Group 117" transform="translate(0)">
            <path
              id="Path_882"
              data-name="Path 882"
              d="M82.478,14.942a.386.386,0,0,0,.386-.386V1.2a1.2,1.2,0,0,0-1.2-1.2H65.977a2.823,2.823,0,0,0-2.82,2.82V4.628a.386.386,0,0,0,.773,0V2.82A2.05,2.05,0,0,1,65.977.773h.192V20.264h-.063a2.942,2.942,0,0,0-2.176.961V6.174a.386.386,0,0,0-.773,0V23.213a2.952,2.952,0,0,0,2.949,2.949H81.539a1.327,1.327,0,0,0,1.325-1.325V16.1a.386.386,0,1,0-.773,0v4.163H66.942V.773H81.667a.425.425,0,0,1,.425.425V14.556A.386.386,0,0,0,82.478,14.942Zm-.386,6.094v3.8a.553.553,0,0,1-.553.552H66.106a2.176,2.176,0,0,1,0-4.353Z"
              transform="translate(-63.157)"
              fill="#080d06"
            />
          </g>
        </g>
        <g
          id="Group_120"
          data-name="Group 120"
          transform="translate(72.225 2.255)"
        >
          <g id="Group_119" data-name="Group 119" transform="translate(0)">
            <path
              id="Path_883"
              data-name="Path 883"
              d="M242.556,44.135a1.93,1.93,0,1,0,1.93,1.93A1.932,1.932,0,0,0,242.556,44.135Zm0,3.087a1.157,1.157,0,1,1,1.157-1.157A1.159,1.159,0,0,1,242.556,47.222Z"
              transform="translate(-240.626 -44.135)"
              fill="#be963a"
            />
          </g>
        </g>
        <g
          id="Group_122"
          data-name="Group 122"
          transform="translate(71.489 6.96)"
        >
          <g id="Group_121" data-name="Group 121" transform="translate(0)">
            <path
              id="Path_884"
              data-name="Path 884"
              d="M231.517,144.611h-.258v-7.757a.644.644,0,0,0-.644-.644H227.29a.836.836,0,0,0-.835.835v1.246a.836.836,0,0,0,.835.835c.04,0,.01-.33.02,5.465,0,.036-.047.013-.258.02a.836.836,0,0,0-.835.835v1.39a.836.836,0,0,0,.835.835h2.757a.386.386,0,0,0,0-.773c-2.769-.028-2.82.058-2.82-.063v-1.39a.063.063,0,0,1,.063-.063h.238a.793.793,0,0,0,.793-.793v-5.445a.794.794,0,0,0-.793-.793.063.063,0,0,1-.063-.063v-1.246a.063.063,0,0,1,.063-.063h3.2v7.843a.385.385,0,0,0,.038.167.6.6,0,0,0,.563.39h.43a.063.063,0,0,1,.063.063v1.39c0,.1-.142.052-.226.063a.386.386,0,0,0,0,.773h.163a.836.836,0,0,0,.835-.835v-1.39A.836.836,0,0,0,231.517,144.611Z"
              transform="translate(-226.216 -136.21)"
              fill="#548438"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
const ProcedureIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19.708"
      height="27.025"
      viewBox="0 0 19.708 27.025"
    >
      <g id="procedure-2" transform="translate(-69.311 0)">
        <g id="Group_126" data-name="Group 126" transform="translate(69.311 0)">
          <path
            id="Path_942"
            data-name="Path 942"
            d="M69.706,19.8a.4.4,0,0,0,.395-.395V.89a.1.1,0,0,1,.1-.1H81.868a.395.395,0,0,0,0-.79H70.2a.891.891,0,0,0-.89.89V19.41A.4.4,0,0,0,69.706,19.8Z"
            transform="translate(-69.311 0)"
            fill="#080d06"
          />
          <path
            id="Path_943"
            data-name="Path 943"
            d="M88.13,0H83.7a.395.395,0,0,0,0,.79H88.13a.1.1,0,0,1,.1.1V21.771h-3.4a.891.891,0,0,0-.89.89v3.574H70.2a.1.1,0,0,1-.1-.1v-4.9a.395.395,0,0,0-.79,0v4.9a.891.891,0,0,0,.89.89H84.334a.4.4,0,0,0,.285-.121l4.29-4.463a.4.4,0,0,0,.11-.274V.89A.891.891,0,0,0,88.13,0ZM86.316,24l-1.587,1.651V22.661a.1.1,0,0,1,.1-.1H87.7Z"
            transform="translate(-69.312 0)"
            fill="#080d06"
          />
          <path
            id="Path_944"
            data-name="Path 944"
            d="M125.294,92.742a.4.4,0,0,0-.554.069l-1.172,1.5-.473-.528a.395.395,0,0,0-.589.527l.788.88a.4.4,0,0,0,.294.132h.013a.4.4,0,0,0,.3-.152l1.462-1.875A.4.4,0,0,0,125.294,92.742Z"
            transform="translate(-119.603 -87.768)"
            fill="#548438"
          />
          <path
            id="Path_945"
            data-name="Path 945"
            d="M215.147,93.062h-8.909a.395.395,0,1,0,0,.79h8.909a.395.395,0,1,0,0-.79Z"
            transform="translate(-198.637 -88.15)"
            fill="#080d06"
          />
          <path
            id="Path_946"
            data-name="Path 946"
            d="M215.147,127.788h-8.909a.395.395,0,1,0,0,.79h8.909a.395.395,0,1,0,0-.79Z"
            transform="translate(-198.637 -121.043)"
            fill="#080d06"
          />
          <path
            id="Path_947"
            data-name="Path 947"
            d="M215.147,285.272h-8.909a.395.395,0,1,0,0,.79h8.909a.395.395,0,1,0,0-.79Z"
            transform="translate(-198.637 -270.215)"
            fill="#080d06"
          />
          <path
            id="Path_948"
            data-name="Path 948"
            d="M215.147,320h-8.909a.395.395,0,1,0,0,.79h8.909a.395.395,0,1,0,0-.79Z"
            transform="translate(-198.637 -303.108)"
            fill="#080d06"
          />
          <path
            id="Path_949"
            data-name="Path 949"
            d="M125.294,188.848a.4.4,0,0,0-.554.069l-1.172,1.5-.473-.528a.395.395,0,1,0-.589.527l.788.88a.4.4,0,0,0,.294.132h.013a.4.4,0,0,0,.3-.152l1.462-1.875a.4.4,0,0,0-.069-.555Z"
            transform="translate(-119.603 -178.801)"
            fill="#548438"
          />
          <path
            id="Path_950"
            data-name="Path 950"
            d="M215.147,189.167h-8.909a.395.395,0,1,0,0,.79h8.909a.395.395,0,1,0,0-.79Z"
            transform="translate(-198.637 -179.182)"
            fill="#080d06"
          />
          <path
            id="Path_951"
            data-name="Path 951"
            d="M215.147,223.893h-8.909a.395.395,0,1,0,0,.79h8.909a.395.395,0,1,0,0-.79Z"
            transform="translate(-198.637 -212.075)"
            fill="#080d06"
          />
          <path
            id="Path_952"
            data-name="Path 952"
            d="M124.877,285.385a.4.4,0,0,0-.559.005l-.618.629-.618-.629a.4.4,0,0,0-.564.553l.628.64-.628.64a.395.395,0,0,0,.564.553l.618-.629.618.629a.395.395,0,1,0,.564-.553l-.628-.64.628-.64A.4.4,0,0,0,124.877,285.385Z"
            transform="translate(-119.604 -270.214)"
            fill="#be963a"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
const ReportPrintIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19.708"
      height="26.648"
      viewBox="0 0 19.708 26.648"
    >
      <g id="business-report" transform="translate(-66.67)">
        <g id="Group_124" data-name="Group 124" transform="translate(66.67)">
          <path
            id="Path_897"
            data-name="Path 897"
            d="M85.987,0H67.06a.39.39,0,0,0-.39.39V18.932a.39.39,0,1,0,.781,0V.781H85.6V3.235a.39.39,0,0,0,.781,0V.39A.39.39,0,0,0,85.987,0Z"
            transform="translate(-66.67)"
            fill="#080d06"
          />
          <path
            id="Path_898"
            data-name="Path 898"
            d="M85.987,89.65a.39.39,0,0,0-.39.39v20.811H67.451v-5.113a.39.39,0,1,0-.781,0v5.5a.39.39,0,0,0,.39.39H85.987a.39.39,0,0,0,.39-.39V90.04A.39.39,0,0,0,85.987,89.65Z"
            transform="translate(-66.67 -84.984)"
            fill="#080d06"
          />
          <path
            id="Path_899"
            data-name="Path 899"
            d="M99,101.005a3.019,3.019,0,1,0,3.019-3.019A3.022,3.022,0,0,0,99,101.005Zm3.019,2.238a2.238,2.238,0,0,1-.39-4.442v2.2a.39.39,0,0,0,.39.39h2.2A2.242,2.242,0,0,1,102.015,103.243Zm2.2-2.629h-1.813V98.8A2.244,2.244,0,0,1,104.219,100.615Z"
            transform="translate(-97.314 -92.886)"
            fill="#080d06"
          />
          <path
            id="Path_900"
            data-name="Path 900"
            d="M103.426,432.35a.39.39,0,0,0-.39.39v1.682a.39.39,0,0,0,.39.39h2.524a.39.39,0,0,0,.39-.39V432.74a.39.39,0,0,0-.39-.39Zm2.133,1.682h-1.743v-.9h1.743Z"
            transform="translate(-101.143 -409.848)"
            fill="#be963a"
          />
          <path
            id="Path_901"
            data-name="Path 901"
            d="M184.24,388.849h2.524a.39.39,0,0,0,.39-.39v-4.206a.39.39,0,0,0-.39-.39H184.24a.39.39,0,0,0-.39.39v4.206A.39.39,0,0,0,184.24,388.849Zm.39-4.206h1.743v3.425h-1.743Z"
            transform="translate(-177.751 -363.883)"
            fill="#080d06"
          />
          <path
            id="Path_902"
            data-name="Path 902"
            d="M265.053,323.252a.39.39,0,0,0-.39.39V331a.39.39,0,0,0,.39.39h2.524a.39.39,0,0,0,.39-.39v-7.361a.39.39,0,0,0-.39-.39Zm2.133,7.361h-1.743v-6.58h1.743Z"
            transform="translate(-254.358 -306.428)"
            fill="#548438"
          />
          <path
            id="Path_903"
            data-name="Path 903"
            d="M348.394,285.007a.39.39,0,0,0,.39-.39V283.24a.39.39,0,0,0-.39-.39H345.87a.39.39,0,0,0-.39.39V292.7a.39.39,0,0,0,.39.39h2.523a.39.39,0,0,0,.39-.39v-6.265a.39.39,0,1,0-.781,0v5.874h-1.742v-8.682H348v.986A.39.39,0,0,0,348.394,285.007Z"
            transform="translate(-330.969 -268.129)"
            fill="#080d06"
          />
          <path
            id="Path_904"
            data-name="Path 904"
            d="M176.489,32.325h-8.412a.39.39,0,0,0-.39.39V34.4a.39.39,0,0,0,.39.39h8.412a.39.39,0,0,0,.39-.39V32.715A.39.39,0,0,0,176.489,32.325Zm-.39,1.682h-7.631v-.9H176.1v.9Z"
            transform="translate(-162.429 -30.643)"
            fill="#080d06"
          />
          <path
            id="Path_905"
            data-name="Path 905"
            d="M256.671,97.986H248.89a.39.39,0,0,0,0,.781h7.781a.39.39,0,1,0,0-.781Z"
            transform="translate(-239.036 -92.886)"
            fill="#080d06"
          />
          <path
            id="Path_906"
            data-name="Path 906"
            d="M256.671,131.658H248.89a.39.39,0,0,0,0,.781h7.781a.39.39,0,1,0,0-.781Z"
            transform="translate(-239.036 -124.806)"
            fill="#080d06"
          />
          <path
            id="Path_907"
            data-name="Path 907"
            d="M257.062,165.72a.39.39,0,0,0-.39-.39H248.89a.39.39,0,0,0,0,.781h7.781A.39.39,0,0,0,257.062,165.72Z"
            transform="translate(-239.036 -156.725)"
            fill="#080d06"
          />
          <path
            id="Path_908"
            data-name="Path 908"
            d="M253.907,199.392a.39.39,0,0,0-.39-.39H248.89a.39.39,0,0,0,0,.781h4.627A.39.39,0,0,0,253.907,199.392Z"
            transform="translate(-239.036 -188.645)"
            fill="#080d06"
          />
          <path
            id="Path_909"
            data-name="Path 909"
            d="M119.616,248.5h-7.1a.39.39,0,1,0,0,.781h7.1a.39.39,0,1,0,0-.781Z"
            transform="translate(-109.762 -235.567)"
            fill="#080d06"
          />
          <path
            id="Path_910"
            data-name="Path 910"
            d="M120.006,282.562a.39.39,0,0,0-.39-.39h-7.1a.39.39,0,1,0,0,.781h7.1A.39.39,0,0,0,120.006,282.562Z"
            transform="translate(-109.762 -267.486)"
            fill="#080d06"
          />
          <path
            id="Path_911"
            data-name="Path 911"
            d="M116.852,316.234a.39.39,0,0,0-.39-.39h-3.943a.39.39,0,1,0,0,.781h3.943A.39.39,0,0,0,116.852,316.234Z"
            transform="translate(-109.762 -299.406)"
            fill="#080d06"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
const AnalysisIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19.708"
      height="21.654"
      viewBox="0 0 19.708 21.654"
    >
      <g id="analysis-2" transform="translate(-0.5 0.001)">
        <path
          id="Path_912"
          data-name="Path 912"
          d="M19.693.459,3.827,0a.53.53,0,0,0-.545.514l-.024.842H1.03a.531.531,0,0,0-.53.53V21.123a.53.53,0,0,0,.53.53H16.9a.53.53,0,0,0,.53-.53V20.7l1.673.048h.016a.529.529,0,0,0,.529-.514L20.208,1a.53.53,0,0,0-.514-.545ZM16.8,21.017H1.136V1.991H16.8Zm2.221-.908-1.585-.046V1.885a.53.53,0,0,0-.53-.53H3.893L3.914.638l15.655.453Zm0,0"
          fill="#080d06"
        />
        <path
          id="Path_913"
          data-name="Path 913"
          d="M61.8,346.952h3.332a.318.318,0,1,0,0-.636H61.8a.318.318,0,1,0,0,.636Zm0,0"
          transform="translate(-58.401 -331.671)"
          fill="#080d06"
        />
        <path
          id="Path_914"
          data-name="Path 914"
          d="M170.445,346.316H168.9a.318.318,0,1,0,0,.636h1.545a.318.318,0,1,0,0-.636Zm0,0"
          transform="translate(-160.973 -331.671)"
          fill="#080d06"
        />
        <path
          id="Path_915"
          data-name="Path 915"
          d="M235.621,346.316h-3.955a.318.318,0,1,0,0,.636h3.955a.318.318,0,1,0,0-.636Zm0,0"
          transform="translate(-221.085 -331.671)"
          fill="#080d06"
        />
        <path
          id="Path_916"
          data-name="Path 916"
          d="M61.8,384.7h2.185a.318.318,0,0,0,0-.636H61.8a.318.318,0,0,0,0,.636Zm0,0"
          transform="translate(-58.401 -367.824)"
          fill="#080d06"
        />
        <path
          id="Path_917"
          data-name="Path 917"
          d="M145.4,384.384a.318.318,0,0,0-.318-.318h-4.493a.318.318,0,1,0,0,.636h4.493A.318.318,0,0,0,145.4,384.384Zm0,0"
          transform="translate(-133.862 -367.824)"
          fill="#080d06"
        />
        <path
          id="Path_918"
          data-name="Path 918"
          d="M280.4,384.066h-1.978a.318.318,0,1,0,0,.636H280.4a.318.318,0,0,0,0-.636Zm0,0"
          transform="translate(-265.865 -367.824)"
          fill="#080d06"
        />
        <path
          id="Path_919"
          data-name="Path 919"
          d="M61.8,422.452h2.7a.318.318,0,1,0,0-.636H61.8a.318.318,0,0,0,0,.636Zm0,0"
          transform="translate(-58.401 -403.978)"
          fill="#080d06"
        />
        <path
          id="Path_920"
          data-name="Path 920"
          d="M149.5,421.816a.318.318,0,0,0,0,.636h3.245a.318.318,0,0,0,0-.636Zm0,0"
          transform="translate(-142.392 -403.978)"
          fill="#080d06"
        />
        <path
          id="Path_921"
          data-name="Path 921"
          d="M255.762,421.816H252.7a.318.318,0,1,0,0,.636h3.066a.318.318,0,0,0,0-.636Zm0,0"
          transform="translate(-241.226 -403.978)"
          fill="#080d06"
        />
        <path
          id="Path_922"
          data-name="Path 922"
          d="M63.465,459.566H61.8a.318.318,0,0,0,0,.636h1.666a.318.318,0,1,0,0-.636Zm0,0"
          transform="translate(-58.401 -440.131)"
          fill="#080d06"
        />
        <path
          id="Path_923"
          data-name="Path 923"
          d="M134.777,459.566h-5.369a.318.318,0,0,0,0,.636h5.369a.318.318,0,0,0,0-.636Zm0,0"
          transform="translate(-123.151 -440.131)"
          fill="#080d06"
        />
        <path
          id="Path_924"
          data-name="Path 924"
          d="M290.476,459.566h-1.533a.318.318,0,0,0,0,.636h1.533a.318.318,0,0,0,0-.636Zm0,0"
          transform="translate(-275.94 -440.131)"
          fill="#080d06"
        />
        <path
          id="Path_925"
          data-name="Path 925"
          d="M54.563,98.7l.3-.406a4.593,4.593,0,0,0,3.212,1.3h.041A4.644,4.644,0,0,0,62.7,94.9a4.656,4.656,0,0,0-.09-.852.523.523,0,0,0-.229-.337.534.534,0,0,0-.4-.074l-3.426.756,1.85-2.775a.53.53,0,0,0-.2-.765,4.637,4.637,0,0,0-6.762,4.07,4.592,4.592,0,0,0,.982,2.892l-.278.383H52.951a.318.318,0,0,0,0,.636h1.355A.318.318,0,0,0,54.563,98.7Zm7.424-4.531h0Zm-7.91.756a4.008,4.008,0,0,1,3.91-3.959h.082a4.007,4.007,0,0,1,1.737.4l-1.929,2.895a.53.53,0,0,0,.555.811l3.576-.79a4.041,4.041,0,0,1,.058.627,3.994,3.994,0,1,1-7.988.02Zm0,0"
          transform="translate(-49.928 -86.51)"
          fill="#548438"
        />
        <path
          id="Path_926"
          data-name="Path 926"
          d="M232.764,94.823H231.2a.318.318,0,0,0-.247.117l-.288.355a3.387,3.387,0,0,0-.48-.4.53.53,0,0,0-.739.138l-1.379,2.027a.53.53,0,0,0,.436.828.541.541,0,0,0,.123-.014l2.47-.581a.53.53,0,0,0,.382-.684,3.37,3.37,0,0,0-.4-.81l.275-.338h1.412a.318.318,0,0,0,0-.636Zm-4.018,2.367,1.165-1.712a2.783,2.783,0,0,1,.925,1.221Zm0,0"
          transform="translate(-217.854 -90.791)"
          fill="#be963a"
        />
      </g>
    </SvgIcon>
  );
};
const SettingIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19.874"
      height="19.874"
      viewBox="0 0 19.874 19.874"
    >
      <g id="setting" transform="translate(0)">
        <g id="Group_125" data-name="Group 125" transform="translate(0 0)">
          <path
            id="Path_927"
            data-name="Path 927"
            d="M18.6,7.763h0a.7.7,0,0,1-.662-.483,8.4,8.4,0,0,0-.462-1.114.7.7,0,0,1,.125-.811l0,0a1.28,1.28,0,0,0,0-1.808L16.33,2.277a1.279,1.279,0,0,0-1.807,0l0,0a.7.7,0,0,1-.812.126,8.4,8.4,0,0,0-1.114-.462.7.7,0,0,1-.483-.666A1.28,1.28,0,0,0,10.833,0H9.041A1.28,1.28,0,0,0,7.763,1.281a.7.7,0,0,1-.483.662,8.4,8.4,0,0,0-1.114.462.7.7,0,0,1-.814-.129,1.28,1.28,0,0,0-1.808,0L2.277,3.544a1.28,1.28,0,0,0,0,1.81.7.7,0,0,1,.126.812A8.4,8.4,0,0,0,1.944,7.28a.7.7,0,0,1-.666.483A1.28,1.28,0,0,0,0,9.041v1.793a1.28,1.28,0,0,0,1.281,1.278.7.7,0,0,1,.662.483,8.393,8.393,0,0,0,.462,1.114.7.7,0,0,1-.129.814,1.28,1.28,0,0,0,0,1.808L3.544,17.6a1.28,1.28,0,0,0,1.81,0,.7.7,0,0,1,.812-.126,8.4,8.4,0,0,0,1.114.462.7.7,0,0,1,.483.666,1.28,1.28,0,0,0,1.278,1.278h1.793a1.28,1.28,0,0,0,1.278-1.281.7.7,0,0,1,.483-.662,8.4,8.4,0,0,0,1.114-.462.7.7,0,0,1,.814.129,1.28,1.28,0,0,0,1.808,0L17.6,16.33a1.28,1.28,0,0,0,0-1.81.7.7,0,0,1-.126-.812,8.4,8.4,0,0,0,.462-1.114.7.7,0,0,1,.666-.483,1.28,1.28,0,0,0,1.278-1.278V9.041A1.28,1.28,0,0,0,18.6,7.763Zm.7,3.071a.7.7,0,0,1-.7.7,1.281,1.281,0,0,0-1.215.882,7.816,7.816,0,0,1-.43,1.036,1.283,1.283,0,0,0,.237,1.487.7.7,0,0,1,0,.984l-1.268,1.268a.7.7,0,0,1-.987,0,1.282,1.282,0,0,0-1.485-.235,7.813,7.813,0,0,1-1.036.429,1.282,1.282,0,0,0-.882,1.218.7.7,0,0,1-.7.7H9.041a.7.7,0,0,1-.7-.7,1.281,1.281,0,0,0-.882-1.215,7.814,7.814,0,0,1-1.036-.429,1.283,1.283,0,0,0-1.487.237.7.7,0,0,1-.984,0L2.688,15.918a.7.7,0,0,1,0-.987,1.282,1.282,0,0,0,.235-1.485A7.817,7.817,0,0,1,2.5,12.411a1.282,1.282,0,0,0-1.218-.882.7.7,0,0,1-.7-.7V9.041a.7.7,0,0,1,.7-.7A1.281,1.281,0,0,0,2.5,7.463a7.816,7.816,0,0,1,.429-1.036A1.283,1.283,0,0,0,2.688,4.94a.7.7,0,0,1,0-.984L3.956,2.688a.7.7,0,0,1,.987,0,1.282,1.282,0,0,0,1.485.235A7.813,7.813,0,0,1,7.463,2.5a1.282,1.282,0,0,0,.882-1.218.7.7,0,0,1,.7-.7h1.793a.7.7,0,0,1,.7.7A1.281,1.281,0,0,0,12.411,2.5a7.817,7.817,0,0,1,1.036.429,1.282,1.282,0,0,0,1.484-.234l0,0a.7.7,0,0,1,.984,0l1.268,1.268a.7.7,0,0,1,0,.983l0,0a1.282,1.282,0,0,0-.235,1.485,7.816,7.816,0,0,1,.43,1.036,1.281,1.281,0,0,0,1.215.882h0a.7.7,0,0,1,.7.7Z"
            transform="translate(0 0)"
            fill="#080d06"
          />
          <path
            id="Path_928"
            data-name="Path 928"
            d="M109,162.772a5.495,5.495,0,0,1-7.739-7.721.291.291,0,0,0-.452-.367,6.077,6.077,0,0,0,8.559,8.54.291.291,0,0,0-.368-.451Z"
            transform="translate(-95.59 -148.576)"
            fill="#080d06"
          />
          <path
            id="Path_929"
            data-name="Path 929"
            d="M151.8,147.591a4.208,4.208,0,1,0,4.208,4.208A4.213,4.213,0,0,0,151.8,147.591Zm0,7.834a3.626,3.626,0,1,1,3.626-3.626A3.63,3.63,0,0,1,151.8,155.425Z"
            transform="translate(-141.861 -141.862)"
            fill="#be963a"
          />
          <path
            id="Path_930"
            data-name="Path 930"
            d="M161.975,99.45a6.022,6.022,0,0,0-3.683,1.243.291.291,0,1,0,.353.463,5.444,5.444,0,0,1,3.329-1.123,5.5,5.5,0,0,1,5.495,5.495,5.445,5.445,0,0,1-1.123,3.33.291.291,0,1,0,.463.353,6.022,6.022,0,0,0,1.243-3.683A6.084,6.084,0,0,0,161.975,99.45Z"
            transform="translate(-152.038 -95.59)"
            fill="#548438"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
const SignOutIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="21.5"
      height="21.499"
      viewBox="0 0 21.5 21.499"
    >
      <g id="log-out" transform="translate(-2.25 -2.25)">
        <path
          id="Path_956"
          data-name="Path 956"
          d="M9,23H5a2.12,2.12,0,0,1-2-2.222V5.222A2.12,2.12,0,0,1,5,3H9"
          transform="translate(0 0)"
          fill="none"
          stroke="#548438"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          id="Path_957"
          data-name="Path 957"
          d="M16,19l5-6L16,7"
          transform="translate(1.999 0)"
          fill="none"
          stroke="#548438"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <line
          id="Line_1"
          data-name="Line 1"
          x1="12"
          transform="translate(11 13)"
          fill="none"
          stroke="#548438"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </SvgIcon>
  );
};
const DataEditIcon = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="225.762"
      height="256"
      viewBox="0 0 225.762 256"
    >
      <g id="Layer_48" transform="translate(-16.119)">
        <g id="Group_83" data-name="Group 83">
          <g id="Group_5" data-name="Group 5">
            <g id="Group_4" data-name="Group 4">
              <circle
                id="Ellipse_1"
                data-name="Ellipse 1"
                cx="39.5"
                cy="39.5"
                r="39.5"
                transform="translate(160.381 88.5)"
                fill="#cfb26e"
              />
            </g>
          </g>
          <g id="Group_7" data-name="Group 7">
            <g id="Group_6" data-name="Group 6">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M211.061,22.25H38.7a5.32,5.32,0,0,0-5.32,5.32V43.25h183V27.57A5.319,5.319,0,0,0,211.061,22.25Z"
                fill="#548438"
              />
            </g>
          </g>
          <g id="Group_9" data-name="Group 9">
            <g id="Group_8" data-name="Group 8">
              <path
                id="Path_6"
                data-name="Path 6"
                d="M199.881,167.5a39.5,39.5,0,1,1,16.5-75.387V43.25h-183V228.43a5.32,5.32,0,0,0,5.32,5.32H211.062a5.32,5.32,0,0,0,5.32-5.32V163.887a39.348,39.348,0,0,1-16.5,3.613Z"
                fill="#fff"
              />
            </g>
          </g>
          <g id="Group_11" data-name="Group 11">
            <g id="Group_10" data-name="Group 10">
              <path
                id="Path_7"
                data-name="Path 7"
                d="M55.881,22.25H38.7a5.32,5.32,0,0,0-5.32,5.32V43.25h22.5v-21Z"
                fill="#cfb26e"
              />
            </g>
          </g>
          <g id="Group_13" data-name="Group 13">
            <g id="Group_12" data-name="Group 12">
              <path
                id="Path_8"
                data-name="Path 8"
                d="M26.212,178.883a6.1,6.1,0,0,1-4.891-4.792.11.11,0,0,0-.217,0,6.1,6.1,0,0,1-4.892,4.792.107.107,0,0,0,0,.213,6.1,6.1,0,0,1,4.892,4.792.11.11,0,0,0,.217,0,6.1,6.1,0,0,1,4.891-4.792.107.107,0,0,0,0-.213Z"
                fill="#548438"
              />
            </g>
          </g>
          <g id="Group_15" data-name="Group 15">
            <g id="Group_14" data-name="Group 14">
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="3.377"
                cy="3.377"
                r="3.377"
                transform="translate(226.888 73.25)"
                fill="#548438"
              />
            </g>
          </g>
          <g id="Group_17" data-name="Group 17">
            <g id="Group_16" data-name="Group 16">
              <path
                id="Path_9"
                data-name="Path 9"
                d="M143.832,249.159a8.546,8.546,0,0,0-6.852,6.713.154.154,0,0,1-.3,0,8.548,8.548,0,0,0-6.852-6.713.15.15,0,0,1,0-.3,8.547,8.547,0,0,0,6.852-6.713.154.154,0,0,1,.3,0,8.547,8.547,0,0,0,6.852,6.713A.15.15,0,0,1,143.832,249.159Z"
                fill="#cfb26e"
              />
            </g>
          </g>
          <g id="Group_19" data-name="Group 19">
            <g id="Group_18" data-name="Group 18">
              <path
                id="Path_10"
                data-name="Path 10"
                d="M116.969,9.242h-1.824v1.824a2.473,2.473,0,0,1-4.946,0V9.242h-1.824a2.473,2.473,0,0,1,0-4.946H110.2V2.473a2.473,2.473,0,1,1,4.946,0V4.3h1.824a2.473,2.473,0,1,1,0,4.945Z"
                fill="#548438"
              />
            </g>
          </g>
          <g id="Group_21" data-name="Group 21">
            <g id="Group_20" data-name="Group 20">
              <circle
                id="Ellipse_3"
                data-name="Ellipse 3"
                cx="3.377"
                cy="3.377"
                r="3.377"
                transform="translate(140.504 4.996)"
                fill="#cfb26e"
              />
            </g>
          </g>
          <g id="Group_23" data-name="Group 23">
            <g id="Group_22" data-name="Group 22">
              <path
                id="Path_11"
                data-name="Path 11"
                d="M216.381,45.75h-183a2.5,2.5,0,0,1-2.5-2.5V27.57A7.829,7.829,0,0,1,38.7,19.75H211.061a7.828,7.828,0,0,1,7.819,7.82V43.25A2.5,2.5,0,0,1,216.381,45.75Zm-180.5-5h178V27.57a2.823,2.823,0,0,0-2.819-2.82H38.7a2.822,2.822,0,0,0-2.819,2.82Z"
              />
            </g>
          </g>
          <g id="Group_25" data-name="Group 25">
            <g id="Group_24" data-name="Group 24">
              <path
                id="Path_12"
                data-name="Path 12"
                d="M180.881,35.25h-111a2.5,2.5,0,0,1,0-5h111a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_27" data-name="Group 27">
            <g id="Group_26" data-name="Group 26">
              <path
                id="Path_13"
                data-name="Path 13"
                d="M204.669,35.25H193.784a2.5,2.5,0,0,1,0-5h10.885a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_29" data-name="Group 29">
            <g id="Group_28" data-name="Group 28">
              <path
                id="Path_14"
                data-name="Path 14"
                d="M216.381,94.1a2.5,2.5,0,0,1-2.5-2.5V43.25a2.5,2.5,0,1,1,5,0V91.6A2.5,2.5,0,0,1,216.381,94.1Z"
              />
            </g>
          </g>
          <g id="Group_31" data-name="Group 31">
            <g id="Group_30" data-name="Group 30">
              <path
                id="Path_15"
                data-name="Path 15"
                d="M211.062,236.25H38.7a7.828,7.828,0,0,1-7.819-7.819V43.25a2.5,2.5,0,0,1,5,0V228.431A2.822,2.822,0,0,0,38.7,231.25H211.061a2.822,2.822,0,0,0,2.819-2.819V164.708a2.5,2.5,0,0,1,5,0v63.723A7.827,7.827,0,0,1,211.062,236.25Z"
              />
            </g>
          </g>
          <g id="Group_33" data-name="Group 33">
            <g id="Group_32" data-name="Group 32">
              <path
                id="Path_16"
                data-name="Path 16"
                d="M55.881,44.938a2.5,2.5,0,0,1-2.5-2.5V22.875a2.5,2.5,0,0,1,5,0V42.438A2.5,2.5,0,0,1,55.881,44.938Z"
              />
            </g>
          </g>
          <g id="Group_35" data-name="Group 35">
            <g id="Group_34" data-name="Group 34">
              <path
                id="Path_17"
                data-name="Path 17"
                d="M154.651,112.407H90.832a2.5,2.5,0,0,1,0-5h63.819a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_37" data-name="Group 37">
            <g id="Group_36" data-name="Group 36">
              <path
                id="Path_18"
                data-name="Path 18"
                d="M82.417,112.407H57.11a2.5,2.5,0,0,1,0-5H82.416a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_39" data-name="Group 39">
            <g id="Group_38" data-name="Group 38">
              <path
                id="Path_19"
                data-name="Path 19"
                d="M151.651,124.288H132.3a2.5,2.5,0,0,1,0-5h19.347a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_41" data-name="Group 41">
            <g id="Group_40" data-name="Group 40">
              <path
                id="Path_20"
                data-name="Path 20"
                d="M123.4,124.288H57.11a2.5,2.5,0,0,1,0-5H123.4a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_43" data-name="Group 43">
            <g id="Group_42" data-name="Group 42">
              <path
                id="Path_21"
                data-name="Path 21"
                d="M151.624,136.169H57.11a2.5,2.5,0,0,1,0-5h94.514a2.5,2.5,0,1,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_45" data-name="Group 45">
            <g id="Group_44" data-name="Group 44">
              <path
                id="Path_22"
                data-name="Path 22"
                d="M153.651,148.05H106.49a2.5,2.5,0,0,1,0-5h47.162a2.5,2.5,0,1,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_47" data-name="Group 47">
            <g id="Group_46" data-name="Group 46">
              <path
                id="Path_23"
                data-name="Path 23"
                d="M97.561,148.05H57.11a2.5,2.5,0,0,1,0-5H97.561a2.5,2.5,0,1,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_49" data-name="Group 49">
            <g id="Group_48" data-name="Group 48">
              <path
                id="Path_24"
                data-name="Path 24"
                d="M192.651,195.05H132.3a2.5,2.5,0,0,1,0-5h60.347a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_51" data-name="Group 51">
            <g id="Group_50" data-name="Group 50">
              <path
                id="Path_25"
                data-name="Path 25"
                d="M123.4,195.05H57.11a2.5,2.5,0,0,1,0-5H123.4a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_53" data-name="Group 53">
            <g id="Group_52" data-name="Group 52">
              <path
                id="Path_26"
                data-name="Path 26"
                d="M192.651,183.169H174.194a2.5,2.5,0,1,1,0-5h18.457a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_55" data-name="Group 55">
            <g id="Group_54" data-name="Group 54">
              <path
                id="Path_27"
                data-name="Path 27"
                d="M165.624,183.169H57.11a2.5,2.5,0,0,1,0-5H165.624a2.5,2.5,0,1,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_57" data-name="Group 57">
            <g id="Group_56" data-name="Group 56">
              <path
                id="Path_28"
                data-name="Path 28"
                d="M172.651,171.288H106.49a2.5,2.5,0,0,1,0-5h66.162a2.5,2.5,0,1,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_59" data-name="Group 59">
            <g id="Group_58" data-name="Group 58">
              <path
                id="Path_29"
                data-name="Path 29"
                d="M97.561,171.288H57.11a2.5,2.5,0,0,1,0-5H97.561a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_61" data-name="Group 61">
            <g id="Group_60" data-name="Group 60">
              <path
                id="Path_30"
                data-name="Path 30"
                d="M159.651,159.931H132.3a2.5,2.5,0,0,1,0-5h27.347a2.5,2.5,0,0,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_63" data-name="Group 63">
            <g id="Group_62" data-name="Group 62">
              <path
                id="Path_31"
                data-name="Path 31"
                d="M123.4,159.931H57.11a2.5,2.5,0,0,1,0-5H123.4a2.5,2.5,0,1,1,0,5Z"
              />
            </g>
          </g>
          <g id="Group_65" data-name="Group 65">
            <g id="Group_64" data-name="Group 64">
              <path
                id="Path_32"
                data-name="Path 32"
                d="M111.076,90.576a2.493,2.493,0,0,1-1.768-.732L98.386,78.921a2.5,2.5,0,0,1,0-3.536l10.922-10.922A2.5,2.5,0,0,1,112.843,68l-9.154,9.154,9.154,9.154a2.5,2.5,0,0,1-1.767,4.27Z"
              />
            </g>
          </g>
          <g id="Group_67" data-name="Group 67">
            <g id="Group_66" data-name="Group 66">
              <path
                id="Path_33"
                data-name="Path 33"
                d="M138.686,90.576a2.5,2.5,0,0,1-1.768-4.267l9.154-9.154L136.918,68a2.5,2.5,0,0,1,3.535-3.535l10.922,10.922a2.5,2.5,0,0,1,0,3.535L140.453,89.844a2.492,2.492,0,0,1-1.767.732Z"
              />
            </g>
          </g>
          <g id="Group_69" data-name="Group 69">
            <g id="Group_68" data-name="Group 68">
              <path
                id="Path_34"
                data-name="Path 34"
                d="M118.176,97.124a2.47,2.47,0,0,1-.895-.167,2.5,2.5,0,0,1-1.438-3.229L129.25,58.789a2.5,2.5,0,0,1,4.667,1.791L120.51,95.519a2.5,2.5,0,0,1-2.334,1.605Z"
              />
            </g>
          </g>
          <g id="Group_80" data-name="Group 80">
            <g id="Group_71" data-name="Group 71">
              <g id="Group_70" data-name="Group 70">
                <path
                  id="Path_35"
                  data-name="Path 35"
                  d="M180.292,137.186a7.218,7.218,0,0,0-2.071,4.319l-.679,6.218a2.783,2.783,0,0,0,3.069,3.069l6.218-.679a7.215,7.215,0,0,0,4.319-2.071l21.84-21.84-10.856-10.856Z"
                  fill="#548438"
                />
              </g>
            </g>
            <g id="Group_73" data-name="Group 73">
              <g id="Group_72" data-name="Group 72">
                <path
                  id="Path_36"
                  data-name="Path 36"
                  d="M206.2,109.8h9.314v15.353H206.2Z"
                  transform="translate(-21.314 183.506) rotate(-45)"
                  fill="#548438"
                />
              </g>
            </g>
            <g id="Group_75" data-name="Group 75">
              <g id="Group_74" data-name="Group 74">
                <path
                  id="Path_37"
                  data-name="Path 37"
                  d="M222.51,108.346l-2.52-2.52a5.894,5.894,0,0,0-8.336,0l-2.934,2.934,10.856,10.856,2.934-2.934a5.9,5.9,0,0,0,0-8.336Z"
                  fill="#cfb26e"
                />
              </g>
            </g>
            <g id="Group_77" data-name="Group 77">
              <g id="Group_76" data-name="Group 76">
                <path
                  id="Path_38"
                  data-name="Path 38"
                  d="M212.989,128.7a2.494,2.494,0,0,1-1.768-.732l-10.856-10.856a2.5,2.5,0,0,1,0-3.535l6.586-6.586a2.5,2.5,0,0,1,3.535,0l10.856,10.856a2.5,2.5,0,0,1,0,3.535l-6.586,6.586A2.489,2.489,0,0,1,212.989,128.7Zm-7.321-13.356,7.321,7.321,3.051-3.05-7.321-7.321Z"
                />
              </g>
            </g>
            <g id="Group_79" data-name="Group 79">
              <g id="Group_78" data-name="Group 78">
                <path
                  id="Path_39"
                  data-name="Path 39"
                  d="M180.3,153.31a5.285,5.285,0,0,1-5.245-5.857l.68-6.219a9.751,9.751,0,0,1,2.787-5.814l31.362-31.361a8.394,8.394,0,0,1,11.872,0l2.521,2.521a8.4,8.4,0,0,1,0,11.871l-31.361,31.361A9.743,9.743,0,0,1,187.1,152.6l-6.219.679c-.2.019-.39.03-.583.03Zm35.52-46.711a3.373,3.373,0,0,0-2.4.994L182.06,138.954a4.738,4.738,0,0,0-1.353,2.823l-.68,6.218a.263.263,0,0,0,.081.23.274.274,0,0,0,.231.082l6.219-.679a4.724,4.724,0,0,0,2.821-1.353l31.362-31.361a3.4,3.4,0,0,0,0-4.8l-2.521-2.521A3.367,3.367,0,0,0,215.821,106.6Z"
                />
              </g>
            </g>
          </g>
          <g id="Group_82" data-name="Group 82">
            <g id="Group_81" data-name="Group 81">
              <path
                id="Path_40"
                data-name="Path 40"
                d="M199.881,170a42,42,0,1,1,42-42A42.047,42.047,0,0,1,199.881,170Zm0-79a37,37,0,1,0,37,37A37.042,37.042,0,0,0,199.881,91Z"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
const HideResult = (props: any) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="17.359"
      height="20.014"
      viewBox="0 0 17.359 20.014"
      {...props}
    >
      <g
        id="Component_6_1"
        data-name="Component 6 – 1"
        transform="translate(1.179 1.178)"
      >
        <g
          id="Icon_ICON_feather_chevron-down_SIZE_MEDIUM_STYLE_STYLE1_"
          data-name="Icon [ICON=feather/chevron-down][SIZE=MEDIUM][STYLE=STYLE1]"
        >
          <path
            id="Path"
            d="M0,0,7.5,7.5,15,0"
            fill="none"
            stroke="#548438"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.667"
          />
        </g>
        <g
          id="Icon_ICON_feather_chevron-down_SIZE_MEDIUM_STYLE_STYLE1_2"
          data-name="Icon [ICON=feather/chevron-down][SIZE=MEDIUM][STYLE=STYLE1]"
          transform="translate(0 10.501)"
        >
          <path
            id="Path-2"
            data-name="Path"
            d="M0,0,7.5,7.5,15,0"
            fill="none"
            stroke="#548438"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.667"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export {
  MainDataIcon,
  ProcedureIcon,
  ReportPrintIcon,
  AnalysisIcon,
  SettingIcon,
  SignOutIcon,
  HideResult,
  DataEditIcon,
};
